export default __webpack_public_path__ + "static/media/logoGob.489333f7.png";